<style lang="scss">
/* ===== PC Layout Container ===== */
.page-inner {
    max-width: 1200px;
    margin: 0 auto;
}

/* ===== Modal Width Override ===== */
:deep(.ant-modal) {
    max-width: none !important;
}

.not-developer-praent {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 60vh;
}

.not-developer-div {
    padding: 1.5rem;
    width: fit-content;
    background: rgba(255, 255, 255, 0.95);
    border-radius: 16px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
    text-align: center;

    p {
        font-size: 1rem;
        color: #333;
        margin-bottom: 1rem;
    }
}

/* ===== Toolbar ===== */
.table-toolbar {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 16px;
    background: #fafafa;
    border-bottom: 1px solid #f0f0f0;
    flex-wrap: wrap;
}

.toolbar-label {
    font-size: 13px;
    color: rgba(0, 0, 0, 0.65);
}

/* ===== Table Card ===== */
.table-card {
    border-radius: 8px;

    :deep(.ant-card-head) {
        border-bottom: 1px solid #f0f0f0;
        padding: 0 16px;
        min-height: 48px;
    }

    :deep(.ant-card-body) {
        padding: 0;
    }
}

/* ===== Mobile Card List ===== */
.version-card-list {
    display: none;
    flex-direction: column;
    gap: 12px;
    padding: 16px;

    .version-mobile-card {
        border-radius: 10px;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);

        :deep(.ant-card-body) {
            padding: 12px 14px;
        }
    }

    .mobile-card-head {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;
        padding-bottom: 8px;
        border-bottom: 1px solid #f0f0f0;
    }

    .mobile-card-title {
        font-weight: 600;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.88);
    }

    .mobile-tag-group {
        display: flex;
        gap: 6px;
        flex-wrap: wrap;
    }

    .mobile-card-body {
        display: flex;
        flex-direction: column;
        gap: 8px;
        margin-bottom: 10px;
    }

    .mobile-field {
        display: flex;
        gap: 8px;
        font-size: 13px;
    }

    .mobile-label {
        color: rgba(0, 0, 0, 0.45);
        min-width: 72px;
        flex-shrink: 0;
        font-size: 12px;
        line-height: 30px;
    }

    .mobile-value {
        flex: 1;
        min-width: 0;
    }

    .mobile-card-foot {
        display: flex;
        gap: 8px;
        padding-top: 8px;
        border-top: 1px solid #f5f5f5;
    }
}

/* ===== Pagination ===== */
.table-pagination {
    display: flex;
    justify-content: flex-end;
    padding: 12px 16px 16px;
}

/* ===== Mobile Responsive ===== */
@media screen and (max-width: 768px) {
    .ant-layout-content {
        padding: 12px !important;
    }

    /* Toggle */
    .version-table-pc,
    .table-pagination {
        display: none !important;
    }

    .version-card-list {
        display: flex !important;
    }

    .table-card :deep(.ant-card-head) {
        padding: 0 12px;
        min-height: 44px;
    }

    .table-toolbar {
        padding: 10px 12px;
    }

    .not-developer-div {
        padding: 1rem;
    }
}

/* Very small phones */
@media screen and (max-width: 480px) {
    .ant-layout-content {
        padding: 8px !important;
    }
}
</style>
<template>
    <a-layout style="min-height: 100vh;">
        <UserHead />
        <a-layout>
            <a-layout-header style="padding: 0; background: #fff; border-bottom: 1px solid #f0f0f0;">
                <HeadTop />
            </a-layout-header>
            <a-layout-content class="page-content" style="padding: 24px; background: #f5f7fa;">
                <div class="page-inner">
                    <div v-if="isDeveloper == 0" class="not-developer-praent">
                        <div class="not-developer-div">
                            <p>您还不是开发者，暂时无法查看本页面喔~</p>
                            <div style="text-align: center; width: fit-content; margin: 1rem auto 0.5rem;">
                                <a-button type="primary" @click="goApiUrl">成为开发者</a-button>
                            </div>
                        </div>
                    </div>

                    <a-card v-if="isDeveloper == 1" :bordered="false" class="table-card">
                        <template #title>
                            <div style="font-weight: 600;">版本日志管理</div>
                        </template>
                        <template #extra>
                            <a-button type="primary" @click="versionRelease.isShow = true">
                                版本发布
                            </a-button>
                        </template>

                        <div class="table-toolbar">
                            <span class="toolbar-label">请选择插件</span>
                            <a-select v-model:value="selectIncludesId" placeholder="请选择" style="width: 200px;"
                                @change="getVersion">
                                <a-select-option label="全部" :value="-1"></a-select-option>
                                <a-select-option v-for="item in includes_data" :key="item.id" :value="item.id">{{
                                    item.id }}---{{ item.name ||
                                        item.includes_name }}</a-select-option>
                            </a-select>
                        </div>

                        <!-- PC端表格 -->
                        <a-table class="version-table-pc" :data-source="versionLogList" :pagination="false" row-key="id"
                            :scroll="{ x: 1400 }" size="small" bordered :columns="versionColumns">
                            <template #bodyCell="{ column, record }">
                                <template v-if="column.key === 'update_desc'">
                                    <a-input style="width: 240px;" type="textarea"
                                        :auto-size="{ minRows: 1, maxRows: 6 }"
                                        v-model:value="record.update_desc"></a-input>
                                </template>
                                <template v-else-if="column.key === 'update_url'">
                                    <a-input v-model:value="record.update_url" placeholder="下载链接"></a-input>
                                </template>
                                <template v-else-if="column.key === 'version_code'">
                                    <a-input style="width: 120px;" v-model:value="record.version_code"></a-input>
                                </template>
                                <template v-else-if="column.key === 'version_name'">
                                    <a-input style="width: 120px;" v-model:value="record.version_name"></a-input>
                                </template>
                                <template v-else-if="column.key === 'version_desc'">
                                    <a-input type="textarea" style="width: 240px;"
                                        :auto-size="{ minRows: 1, maxRows: 6 }"
                                        v-model:value="record.version_desc"></a-input>
                                </template>
                                <template v-else-if="column.key === 'action'">
                                    <a-space size="small">
                                        <a-button type="primary" size="small"
                                            @click="saveVersionLog(record)">保存</a-button>
                                        <a-button danger size="small" @click="deleteVersionLog(record.id)">删除</a-button>
                                    </a-space>
                                </template>
                            </template>
                        </a-table>

                        <!-- 手机端卡片列表 -->
                        <div class="version-card-list" v-if="versionLogList && versionLogList.length > 0">
                            <a-card v-for="record in versionLogList" :key="record.id" class="version-mobile-card"
                                :bordered="false">
                                <div class="mobile-card-head">
                                    <span class="mobile-card-title">插件 #{{ record.includes_id }} - v{{
                                        record.version_name || record.version_code }}</span>
                                    <div class="mobile-tag-group">
                                        <a-tag color="blue">{{ record.version_code }}</a-tag>
                                    </div>
                                </div>
                                <div class="mobile-card-body">
                                    <div class="mobile-field">
                                        <span class="mobile-label">更新步骤</span>
                                        <span class="mobile-value">
                                            <a-input type="textarea" :auto-size="{ minRows: 1, maxRows: 4 }"
                                                v-model:value="record.update_desc"></a-input>
                                        </span>
                                    </div>
                                    <div class="mobile-field">
                                        <span class="mobile-label">版本介绍</span>
                                        <span class="mobile-value">
                                            <a-input type="textarea" :auto-size="{ minRows: 1, maxRows: 4 }"
                                                v-model:value="record.version_desc"></a-input>
                                        </span>
                                    </div>
                                    <div class="mobile-field">
                                        <span class="mobile-label">下载URL</span>
                                        <span class="mobile-value">
                                            <a-input v-model:value="record.update_url" placeholder="下载链接"></a-input>
                                        </span>
                                    </div>
                                </div>
                                <div class="mobile-card-foot">
                                    <a-button type="primary" size="small" @click="saveVersionLog(record)">保存</a-button>
                                    <a-button danger size="small" @click="deleteVersionLog(record.id)">删除</a-button>
                                </div>
                            </a-card>
                        </div>

                        <!-- 空状态 -->
                        <a-empty v-if="(!versionLogList || versionLogList.length === 0)" description="暂无版本日志"
                            style="padding: 32px;" />

                        <!-- 分页 -->
                        <div class="table-pagination">
                            <a-pagination v-model:current="versionPage.currentPage" :page-size="versionPage.pageSize"
                                :page-size-options="[5, 10, 20]" show-size-changer show-quick-jumper
                                :show-total="(total) => `共 ${total} 条`" :total="versionPage.total"
                                @change="currentChange" />
                        </div>
                    </a-card>
                </div>
            </a-layout-content>
        </a-layout>
    </a-layout>

    <!-- 版本发布 -->
    <a-modal v-model:open="versionRelease.isShow" title="版本发布" :width="560" :footer="null" centered>
        <a-form layout="vertical">
            <a-form-item label="插件">
                <a-select v-model:value="versionRelease.data.includes_id" placeholder="请选择">
                    <a-select-option v-for="item in includes_data" :key="item.id" :value="item.id">
                        {{ item.id }}---{{ item.name || item.includes_name }}
                    </a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item label="安装步骤">
                <a-input type="textarea" :rows="3" :auto-size="{ minRows: 3, maxRows: 6 }"
                    v-model:value="versionRelease.data.update_desc" autocomplete="off" />
            </a-form-item>
            <a-form-item label="更新介绍">
                <a-input type="textarea" :auto-size="{ minRows: 1, maxRows: 6 }"
                    v-model:value="versionRelease.data.version_desc" autocomplete="off" />
            </a-form-item>
            <a-form-item label="版本号">
                <a-input v-model:value="versionRelease.data.version_code" autocomplete="off" />
            </a-form-item>
            <a-form-item label="版本名称">
                <a-input v-model:value="versionRelease.data.version_name" autocomplete="off" />
            </a-form-item>
            <a-form-item label="下载链接">
                <a-input v-model:value="versionRelease.data.update_url" autocomplete="off" />
            </a-form-item>
        </a-form>
        <div style="text-align: right; margin-top: 16px;">
            <a-button @click="versionRelease.isShow = false">关闭</a-button>
            <a-button type="primary" @click="addVersionLog">新增</a-button>
        </div>
    </a-modal>
</template>
<script>
import { defineComponent } from 'vue';
import UserHead from '@/components/UserHead.vue';
import HeadTop from '@/components/UserHeadTop.vue';
import { isLogin, isNull, compareDates, openBox, getIncludesList } from "@/utils/publicMethods"
import { message } from 'ant-design-vue'
import { openLoading, fullscreenLoading } from '@/utils/loadingUtils'
import axios from 'axios';
const baseURL = process.env.VUE_APP_API_BASE_URL;
export default defineComponent({
    components: {
        UserHead,
        HeadTop
    },
    data() {
        return {
            isDeveloper: 2,
            deveploerConf: {
                apiUrl: ""
            },
            versionLogList: [],
            versionColumns: [
                { title: '插件ID', dataIndex: 'includes_id', key: 'includes_id', width: 80, align: 'center' },
                { title: '更新步骤', dataIndex: 'update_desc', key: 'update_desc', width: 260 },
                { title: '下载URL', dataIndex: 'update_url', key: 'update_url' },
                { title: '版本号', dataIndex: 'version_code', key: 'version_code', width: 120 },
                { title: '版本名称', dataIndex: 'version_name', key: 'version_name', width: 120 },
                { title: '版本介绍', dataIndex: 'version_desc', key: 'version_desc', width: 260 },
                { title: '操作', key: 'action', width: 140, align: 'center' },
            ],
            versionPage: {
                currentPage: 1,
                pageSize: 5,
                total: 0
            },
            versionRelease: {
                isShow: false,
                data: {
                    includes_id: "",
                    version_code: "",
                    version_name: "",
                    version_desc: "",
                    update_desc: "",
                    update_url: ""
                }
            },
            includes_data: [],
            selectIncludesId: -1
        }
    },
    methods: {
        goApiUrl() {
            location.href = this.deveploerConf.apiUrl;
        },
        isNull(text) {
            return isNull(text);
        },
        currentChange(page, pageSize) {
            this.versionPage.currentPage = page;
            this.versionPage.pageSize = pageSize;
            this.getVersion();
        },
        getVersion() {
            openLoading()
            const data = new FormData();
            const headers = {
                'token': localStorage.getItem("token")
            }
            data.append("includes_id", this.selectIncludesId + "")
            data.append("currentPage", this.versionPage.currentPage + "")
            data.append("pageSize", this.versionPage.pageSize + "")
            axios.post(baseURL + '/versionLog/list', data, { timeout: 30000, headers })
                .then(res => {
                    if (res.data.code == 200) {
                        this.isDeveloper = 1;
                        this.versionLogList = res.data.data.list;
                        this.versionPage.total = res.data.data.total;
                    } else if (res.data.code == 403) {
                        this.isDeveloper = 0;
                        this.deveploerConf.apiUrl = res.data.data;
                        openBox(this.deveploerConf.apiUrl)
                    }
                    else {
                        message.error(res.data.msg)
                    }
                    if (res.data.code == 401) {
                        setTimeout(() => {
                            location.href = "/Login"
                        }, 1000);

                    }
                }).catch(err => {
                    message.error(err)
                }).finally(() => {
                    fullscreenLoading.close()
                })
        },
        getVersionByIncludes() {
            openLoading()
            const data = new FormData();
            const headers = {
                'token': localStorage.getItem("token")
            }
            data.append("currentPage", this.versionPage.currentPage + "")
            data.append("pageSize", this.versionPage.pageSize + "")
            data.append("includes_id", this.versionRelease.data.includes_id + "")
            axios.post(baseURL + '/versionLog/list', data, { timeout: 30000, headers })
                .then(res => {
                    if (res.data.code == 200) {
                        this.isDeveloper = 1;
                        this.versionLogList = res.data.data.list;
                        this.versionPage.total = res.data.data.total;
                    } else if (res.data.code == 403) {
                        this.isDeveloper = 0;
                        this.deveploerConf.apiUrl = res.data.data;
                        openBox(this.deveploerConf.apiUrl)
                    }
                    else {
                        message.error(res.data.msg)
                    }
                    if (res.data.code == 401) {
                        setTimeout(() => {
                            location.href = "/Login"
                        }, 1000);

                    }
                }).catch(err => {
                    message.error(err)
                }).finally(() => {
                    fullscreenLoading.close()
                })
        },
        saveVersionLog(row) {
            openLoading()
            const headers = {
                'token': localStorage.getItem("token"),
                'Content-Type': 'application/json'
            }
            axios.post(baseURL + '/versionLog/save', JSON.stringify(row), { timeout: 30000, headers })
                .then(res => {
                    if (res.data.code == 200) {
                        this.isDeveloper = 1;
                        message.success(res.data.msg)
                    } else if (res.data.code == 403) {
                        this.isDeveloper = 0;
                        this.deveploerConf.apiUrl = res.data.data;
                        openBox(this.deveploerConf.apiUrl)
                    }
                    else {
                        message.error("失败")
                    }
                    if (res.data.code == 401) {
                        setTimeout(() => {
                            location.href = "/Login"
                        }, 1000);

                    }
                }).catch(err => {
                    message.error("错误：" + err)
                }).finally(() => {
                    fullscreenLoading.close()
                })
        },
        getIncludes() {
            const headers = {
                'token': localStorage.getItem("token")
            }
            axios.get(baseURL + '/dev/getIncludes', { timeout: 30000, headers }).then(
                res => {
                    if (res.data.code == 200) {
                        this.includes_data = res.data.data
                    } else {
                        message.error(res.data.msg)
                    }
                }, err => {
                    message.error(err)
                }
            )
        },
        deleteVersionLog(id) {
            openLoading()
            const data = new FormData();
            const headers = {
                'token': localStorage.getItem("token")
            }
            axios.get(baseURL + '/versionLog/delete?versionId=' + id, { timeout: 30000, headers })
                .then(res => {
                    if (res.data.code == 200) {
                        this.isDeveloper = 1;
                        message.success(res.data.msg);
                        this.getVersion();
                    } else if (res.data.code == 403) {
                        this.isDeveloper = 0;
                        this.deveploerConf.apiUrl = res.data.data;
                        openBox(this.deveploerConf.apiUrl)
                    }
                    else {
                        message.error(res.data.msg)
                    }
                    if (res.data.code == 401) {
                        setTimeout(() => {
                            location.href = "/Login"
                        }, 1000);

                    }
                }).catch(err => {
                    message.error(err)
                }).finally(() => {
                    fullscreenLoading.close()
                })
        },
        addVersionLog() {
            openLoading()
            const data = new FormData();
            const headers = {
                'token': localStorage.getItem("token"),
                'Content-Type': 'application/json'
            }
            axios.post(baseURL + '/versionLog/add', JSON.stringify(this.versionRelease.data), { timeout: 30000, headers })
                .then(res => {
                    if (res.data.code == 200) {
                        this.isDeveloper = 1;
                        message.success(res.data.msg);
                        this.versionRelease.isShow = false;
                        this.getVersion();
                    } else if (res.data.code == 403) {
                        this.isDeveloper = 0;
                        this.deveploerConf.apiUrl = res.data.data;
                        openBox(this.deveploerConf.apiUrl)
                    }
                    else {
                        message.error(res.data.msg)
                    }
                    if (res.data.code == 401) {
                        setTimeout(() => {
                            location.href = "/Login"
                        }, 1000);

                    }
                }).catch(err => {
                    message.error(err)
                }).finally(() => {
                    fullscreenLoading.close()
                })
        }
    },
    mounted() {
        this.getVersion()
        this.getIncludes()
    }
})
</script>
